import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from "react-router-dom";
import {baseUrl} from "../Univ";
function WorkerTasks() {
    const userId = localStorage.getItem("user_id");
    const [worker, setWorker] = useState(null);
    const [workerId, setWorkerId] = useState(null);
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(false);
// ---------------- WORKER PROFILE ----------------
    useEffect(() => {
        if (!userId) return;
        axios.get(
            baseUrl + "worker-profile/" + userId + "/"
        )
            .then((res) => {
                if (res.data.length > 0) {
                    setWorker(res.data[0]);
                    setWorkerId(res.data[0].id);
                }
            })
            .catch(console.log);
    }, [userId]);
// ---------------- ASSIGNMENTS ----------------
    const fetchAssignments = async () => {
        if (!workerId) return;
        try {
            setLoading(true);
            const res = await axios.get(
                baseUrl + "assignment-worker/" + workerId + "/"
            );
            console.log("Assignments =", res.data);
            setAssignments(res.data);
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
        }
    };
    useEffect(() => {
        if (workerId) {
            fetchAssignments();
        }
    }, [workerId]);
    return (
        <section className="container mt-4">

            <div className="page-header">

                <h3>
                    My Assigned Tasks
                </h3>

                <small>
                    View Assigned Work, Attendance, Payments & Disputes
                </small>

            </div>

            {worker && (
                <div className="card app-profile-card mb-4">

                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center flex-wrap">

                            <div>

                                <h4 className="fw-bold mb-2">

                                    👨‍🌾 {worker.name}

                                </h4>

                                <p className="mb-1">

                                    📞 {worker.mobile}

                                </p>

                                <p className="mb-1">

                                    🛠 {worker.work_type}

                                </p>

                                <p className="mb-0">

                                    💰 ₹{worker.cost} / {worker.unit}

                                </p>

                            </div>

                            <div className="text-center">

                                <h2 className="text-success fw-bold">

                                    {assignments.length}

                                </h2>

                                <small>

                                    Assigned Tasks

                                </small>

                            </div>

                        </div>

                    </div>

                </div>
            )}

            {loading && (
                <div className="alert alert-info">

                    Loading Tasks...

                </div>
            )}

            {!loading && assignments.length === 0 && (
                <div className="alert alert-warning">

                    No Assigned Tasks Found

                </div>
            )}

            <div className="row">

                {assignments.map((item) => {
                    const req = item.requirement;
                    return (
                        <div
                            className="col-lg-4 col-md-6 mb-4"
                            key={item.id}
                        >

                            <div className="card app-card h-100">

                                <div className="app-card-header">

                                    🌱 {req?.crop_type}

                                </div>

                                <div className="app-card-body">

                                    <p>

                                        <strong>
                                            📍 Location :
                                        </strong>
                                        {" "}
                                        {req?.location}

                                    </p>

                                    <p>

                                        <strong>
                                            📮 Pincode :
                                        </strong>
                                        {" "}
                                        {req?.pincode}

                                    </p>

                                    <p>

                                        <strong>
                                            🌾 Land Size :
                                        </strong>
                                        {" "}
                                        {req?.land_size}
                                        {" "}
                                        {req?.land_unit}

                                    </p>

                                    <p>

                                        <strong>
                                            💵 Budget :
                                        </strong>
                                        {" "}
                                        ₹{req?.budget}

                                    </p>

                                    <hr/>

                                    <p>

                                        <strong>
                                            👤 Owner :
                                        </strong>
                                        {" "}
                                        {req?.owner?.name}

                                    </p>

                                    <p>

                                        <strong>
                                            📞 Mobile :
                                        </strong>
                                        {" "}
                                        {req?.owner?.mobile}

                                    </p>

                                    <hr/>

                                    <div className="row text-center">

                                        <div className="col-6">

                                            <div className="app-stat-box">

                                                <h5>

                                                    {item.total_present_days}

                                                </h5>

                                                <small>

                                                    Present Days

                                                </small>

                                            </div>

                                        </div>

                                        <div className="col-6">

                                            <div className="app-stat-box">

                                                <h5>

                                                    ₹{item.total_amount}

                                                </h5>

                                                <small>

                                                    Earned

                                                </small>

                                            </div>

                                        </div>

                                    </div>

                                    <div className="mt-3">

                                        <strong>
                                            Status :
                                        </strong>

                                        {" "}

                                        <span
                                            className={`badge ${
                                                item.status === "ACTIVE"
                                                    ? "bg-success"
                                                    : item.status === "COMPLETED"
                                                        ? "bg-primary"
                                                        : "bg-danger"
                                            }`}
                                        >
                  {item.status}
                </span>

                                    </div>

                                </div>

                                <div className="app-card-footer">

                                    <div className="d-grid gap-2">

                                        <Link
                                            to={`/worker-attendance/${item.id}`}
                                            className="btn btn-warning fw-bold"
                                        >
                                            📅 Attendance
                                        </Link>

                                        <Link
                                            to={`/worker-payments/${item.id}`}
                                            className="btn btn-success fw-bold"
                                        >
                                            💰 Payments
                                        </Link>

                                        <Link
                                            to={`/worker-disputes/${item.id}`}
                                            className="btn btn-danger fw-bold"
                                        >
                                            ⚠ Raise Dispute
                                        </Link>

                                    </div>

                                </div>

                            </div>

                        </div>
                    );
                })}

            </div>

        </section>
    );
}
export default WorkerTasks;